import { ActionIcon } from "@mantine/core";
import styled from "styled-components";

const MainBodyWrapper = styled.div`
  margin: 0 auto !important;
  min-height: 550px;

  p {
    color: inherit;
    font-size: 14px;
    line-height: 1.55;
    text-decoration: none;
  }
  .home-feature-upload-icon {
    position: absolute;
    top: 12px;
    right: 24px;
    z-index: 10;
  }
`;

const HomeFeatureWrapper = styled.div`
  background-image: url("/images/3.jpg");
  background-size: cover; // Ensures the image covers the entire container
  background-repeat: no-repeat; // Prevents tiling
  background-position: center; // Centers the image horizontally and vertically
  position: relative;
  left: 50%;
  right: 50%;
  height: 340px;
  margin-left: -50vw;
  margin-right: -50vw;
  width: 100vw;
  background-color: #f0f0f0;
  padding: 1rem;
  margin-bottom: 20px;
`;

const StyledImage = styled.img`
  display: block;
  width: 100vw;
  height: 420px;
  object-fit: cover;
`;

const UploadIcon = styled(ActionIcon)`
  position: absolute;
  top: 12px;
  right: 24px;
  z-index: 10;
`;
export { HomeFeatureWrapper, MainBodyWrapper, StyledImage, UploadIcon };

// const MainBodyWrapper = styled.div`
//   //margin: 0 auto !important;
//   min-height: 550px;

//   p {
//     color: inherit;
//     font-size: 14px;
//     line-height: 1.55;
//     text-decoration: none;
//     text-align: center;
//   }
//   .home-feature-wrapper {
//     position: relative;
//     width: 100vw;
//   }

//   .home-feature-upload-icon {
//     position: absolute;
//     top: 12px;
//     right: 24px;
//     z-index: 10;
//   }
//   // .home-feature-wrapper {
//   //   position: relative;
//   //   height: 430px;
//   //   margin: 0 auto;
//   //   margin-bottom: 20px;
//   // }
//   .home-feature-image-wrapper {
//     position: relative;
//   }

//   .home-feature-image-wrapper .mantine-ActionIcon-root {
//     position: absolute;
//     top: 8px;
//     right: 8px;
//   }

//   /* Full-width banner */
//   .home-feature-logo {
//     display: block;
//     width: 100vw;
//     margin-right: calc(-50vw + 50%);
//     margin-left: calc(-50vw + 50%);
//     height: 420px;
//   }

//   /* Layout: center items in row */
//   // .home-feature-wrapper {
//   //   display: flex;
//   //   flex-wrap: wrap;
//   //   justify-content: center;
//   //   align-items: flex-start;
//   //   gap: 16px;
//   // }

//   /* Container for the 3 items */
//   .home-feature-item {
//     margin-top: -120px; /* overlap hero by 50px */
//     margin-left: 16px;
//     margin-right: 16px;
//   }
// `;

// export { MainBodyWrapper };
